import React, { useState } from 'react'
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CustomMenu from '../../../../components/Menu';
import Active from './Active';
import ImpersonateUser from './ImpersonateUser';
import DeleteUser from './DeleteUser';
import ResendInvite from './ResendInvite';

function Action({ params }) {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };
    
  return (
    <>
      <MoreVertIcon
        className="user-management-action-icon cursor-pointer"
        onClick={handleClick}
      />
      <CustomMenu
        anchorEl={anchorEl}
        open={!!anchorEl}
        handleClose={handleMenuClose}
        keepMounted
      >
        {params.row.active && (
          <ImpersonateUser params={params} onMenuClose={handleMenuClose} />
        )}
        <Active
          isActive={params.row.active}
          userId={params.row.user_id}
          onMenuClose={handleMenuClose}
        />
        {params.row.active && (
          <ResendInvite params={params} onMenuClose={handleMenuClose} />
        )}
        {params.row.active && (
          <DeleteUser params={params} onMenuClose={handleMenuClose} />
        )}
        {/* <CustomMenuItem>Delete user</CustomMenuItem> */}
      </CustomMenu>
    </>
  );
}

export default Action
